import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HrisSyncSidebarQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type HrisSyncSidebarQuery = { __typename?: 'Query', MergeBackfillRun?: { __typename?: 'MergeBackfillRun', id: number, createdAt: string, updatedAt: string, queuedAt?: string | null, startedAt?: string | null, completedAt?: string | null, isNightlyResync?: boolean | null, modifiedEmployeesCount: number, modifiedActiveEmployeesCount: number, hrisIntegration: { __typename?: 'HrisIntegration', id: string, hrisProvider?: string | null } } | null };


export const HrisSyncSidebarDocument = gql`
    query HrisSyncSidebar($id: Int!) {
  MergeBackfillRun(id: $id) {
    id
    createdAt
    updatedAt
    queuedAt
    startedAt
    completedAt
    isNightlyResync
    modifiedEmployeesCount
    modifiedActiveEmployeesCount
    hrisIntegration {
      id
      hrisProvider
    }
  }
}
    `;

/**
 * __useHrisSyncSidebarQuery__
 *
 * To run a query within a React component, call `useHrisSyncSidebarQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrisSyncSidebarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHrisSyncSidebarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHrisSyncSidebarQuery(baseOptions: Apollo.QueryHookOptions<HrisSyncSidebarQuery, HrisSyncSidebarQueryVariables> & ({ variables: HrisSyncSidebarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HrisSyncSidebarQuery, HrisSyncSidebarQueryVariables>(HrisSyncSidebarDocument, options);
      }
export function useHrisSyncSidebarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HrisSyncSidebarQuery, HrisSyncSidebarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HrisSyncSidebarQuery, HrisSyncSidebarQueryVariables>(HrisSyncSidebarDocument, options);
        }
export type HrisSyncSidebarQueryHookResult = ReturnType<typeof useHrisSyncSidebarQuery>;
export type HrisSyncSidebarLazyQueryHookResult = ReturnType<typeof useHrisSyncSidebarLazyQuery>;
export type HrisSyncSidebarQueryResult = Apollo.QueryResult<HrisSyncSidebarQuery, HrisSyncSidebarQueryVariables>;